import Check from '@mui/icons-material/CheckCircle';
import Failed from '@mui/icons-material/Cancel';
import { CircularProgress } from '@mui/material';
import { PROVIDER_STATUS } from 'hooks/MyCareNetwork';

export const getCareCenterStatusTextAndIcon = (status) => {
  switch (status) {
    case 'failure':
    case PROVIDER_STATUS.VALIDATION_FAILED:
    case PROVIDER_STATUS.ERROR:
    case PROVIDER_STATUS.CANCELLED:
      return {
        status : 'Failed',
        icon   : <Failed
          fontSize='small' sx={{ color: '#cf193e', ml: '5px' }}
        />,
        color : '#cf193e',
      };
    case PROVIDER_STATUS.SUCCESS:
    case PROVIDER_STATUS.VALIDATION_SUCCESS:
      return {
        status : 'Success',
        icon   : <Check
          fontSize='small' sx={{ color: '#26934d', ml: '5px' }}
        />,
        color : '#26934d',
      };
    default:
      return {
        status : 'In Progress',
        icon   : (
          <CircularProgress
            size={15} sx={{ color: '#26934d', ml: '5px' }}
          />
        ),
        color : '#97ae16',
      };
  }
};
